import { FIELD_TYPES } from "constants/template-field-type";
import TitleConfig from "segments/desktop/core-components/title/fields-config";
import ParagraphConfig from "segments/desktop/core-components/paragraph/fields-config";

const { titleColor, ...restOfTitleConfig } = TitleConfig;
const { bodyColor, ...restOfParagraphConfig } = ParagraphConfig;

export default {
  type: FIELD_TYPES.NESTED,
  label: "Products Cards",
  fields: {
    cardBackgroundColor: { type: FIELD_TYPES.COLOR_PICKER, label: "Card background color" },
    productType: { type: FIELD_TYPES.PRODUCTS, label: "Product type" },
    cardTitle: {
      type: FIELD_TYPES.NESTED,
      label: "Card title",
      fields: {
        productImage: { type: FIELD_TYPES.GALLERY, label: "Product logo image" },
        ...restOfTitleConfig,
        ...restOfParagraphConfig
      }
    },
    cardContent: {
      type: FIELD_TYPES.NESTED,
      label: "Card content",
      fields: {
        ...restOfTitleConfig,
        ...restOfParagraphConfig,
        textWidth: { type: FIELD_TYPES.TEXT, label: "Text max width" },
        titleWidth: { type: FIELD_TYPES.TEXT, label: "Title max width" },
        useCasesWidth: { type: FIELD_TYPES.TEXT, label: "Use case max width" },
        isUseCasesReadonly: { type: FIELD_TYPES.BOOLEAN, label: "Is use cases read only" },
        showUseCasesVertically: { type: FIELD_TYPES.BOOLEAN, label: "Show Use Cases Vertically" },
        cardPaddingTop: { type: FIELD_TYPES.TEXT, label: "Card Padding Top" },
        cardPaddingBottom: { type: FIELD_TYPES.TEXT, label: "Card Padding Bottom" },
        spaceUnderTitle: { type: FIELD_TYPES.TEXT, label: "Space Under Title" },
        useCases: {
          type: FIELD_TYPES.MULTIPLE_NESTED,
          label: "Use cases",
          nestedConfig: {
            type: FIELD_TYPES.NESTED,
            fields: {
              useCase: { type: FIELD_TYPES.TEXT, label: "Use cases" },
              overridePageCluster: {
                type: FIELD_TYPES.CLUSTERS,
                label: "Cluster key",
                labelDescription: "Key which represents the selected tag cluster"
              },
              overridePageSubCluster: {
                type: FIELD_TYPES.SUB_CLUSTERS,
                label: "Use Case key",
                labelDescription: "Key which represents the selected tag use case"
              }
            }
          }
        },
        features: {
          type: FIELD_TYPES.MULTIPLE_NESTED,
          label: "Features",
          nestedConfig: {
            type: FIELD_TYPES.NESTED,
            fields: {
              feature: { type: FIELD_TYPES.TEXT, label: "Feature" }
            }
          }
        }
      }
    },
    cardAsset: { type: FIELD_TYPES.GALLERY, label: "Card asset" }
  }
};
